// @flow

import * as React from 'react'

export type WebshopDesignPageRendererContextValue = {
  headerBackdropGridItems: Array<Object>,
  setHeaderBackdropGridItems: (headerBackdropGridItems: Array<Object>) => void,
}

export const WebshopDesignPageRendererContext: React.Context<WebshopDesignPageRendererContextValue> =
  React.createContext({
    headerBackdropGridItems: [],
    setHeaderBackdropGridItems: () => {},
  })

export const useWebshopDesignPageRendererContext = () => {
  const [headerBackdropGridItems, setHeaderBackdropGridItems] = React.useState<
    Array<Object>
  >([])

  return {
    headerBackdropGridItems,
    setHeaderBackdropGridItems,
  }
}
